import { __exports as withTouchListeners$1 } from "../../../_virtual/withTouchListeners.js";
import React__default from "react";
import { e as exenvExports } from "../../exenv/index.js";
import "./utils.js";
import { __exports as utils } from "../../../_virtual/utils.js";
Object.defineProperty(withTouchListeners$1, "__esModule", {
  value: true
});
var _createClass = /* @__PURE__ */ function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
withTouchListeners$1.default = withTouchListeners;
var _react = React__default;
var _react2 = _interopRequireDefault(_react);
var _exenv = exenvExports;
var _utils = utils;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function withTouchListeners(WrappedComponent) {
  return function(_PureComponent) {
    _inherits(TouchProvider, _PureComponent);
    function TouchProvider() {
      _classCallCheck(this, TouchProvider);
      return _possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
    }
    _createClass(TouchProvider, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!_exenv.canUseDOM || !(0, _utils.isTouchDevice)())
          return;
        document.addEventListener("touchmove", _utils.preventTouchMove, _utils.listenerOptions);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (!_exenv.canUseDOM || !(0, _utils.isTouchDevice)())
          return;
        document.removeEventListener("touchmove", _utils.preventTouchMove, _utils.listenerOptions);
      }
    }, {
      key: "render",
      value: function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      }
    }]);
    return TouchProvider;
  }(_react.PureComponent);
}
//# sourceMappingURL=withTouchListeners.js.map
